import React from "react";
import styles from './DeleteCustomer.module.css'
import { useState } from "react";
import { isValidEmail } from "../../../Utils/isValidEmail";
import { deleteCustomer } from "../../../Utils/deleteCustomer";
export function DeleteCustomer(){
    const [error, setError] = useState()
    const [username, setUsername] = useState()
    const updateError = (error_message) =>{
        setError(error_message)
        setInterval(() => {
            setError()
        }, 5000);
    }
    const handleClick = ()=>{
        if (!username) return updateError('No email was typed')
        if (!isValidEmail(username)) return updateError('No valid email')
        deleteCustomer(username)
        .then(res=>{
            if (res.status===200) updateError('No valid email')
            else if (res.status===404) updateError('This email is not an user anymore')
            else updateError('An error occurred')
        })
    }
    return (<div className={styles.main}>
        <h1>User Deletion</h1>
        <div className={styles.inputs}>
            <input onChange={(e)=>setUsername(e.target.value)} className={styles.username_input} placeholder="Insert username" />
            <button onClick={()=>handleClick()} className={styles.button}>Delete</button>
        </div>
        <div className={styles.message}>{error}</div>
    </div>)
}